import React, { useEffect, useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import Moment from 'react-moment'
import * as rest from '../../services'
import {Field, formValueSelector, reduxForm} from 'redux-form'
import {FormButtons, validations, renderers, ICONS, titleCase, upperCase} from '../../components'
import { Slider } from '../../components'
import {useSelector, useDispatch, connect} from 'react-redux'
import { getLists } from '../../state/lists'
import { showErrorToast, showSuccessToast } from '../../state/toasts'

const FORM_NAME = 'nonSerializedOrderLine-form'
let NonSerializedOrderLineForm = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
  dispatch,
 description
}) => {
  const { serializable_inventory_item } = useSelector((state) => state.lists)
  const [partNumbersSearchText, setPartNumbersSearchText] = useState(null)
  const [partNumbers, setPartNumbers] = useState(null)
     const { user } = useSelector((state) => state.auth)
  useEffect(() => {
    !serializable_inventory_item &&
      dispatch(getLists('SERIALIZABLE_INVENTORY_ITEM'))
  }, [serializable_inventory_item, dispatch, partNumbers])

  const onDescriptionChange = (x) => {
      let v = description
      if(x){
        const { value } = x.target
        v = value
      }
    setPartNumbers(null)
    new rest.SerializableInventoryService()
      .get_part_number_by_description(v)
      .then((res) => {
        setPartNumbers(res)
      })
  }

  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Col xs="12">
        <Field
          name="description"
          as="select"
          onChange={onDescriptionChange}
          validate={[validations.required]}
          component={renderers.renderSelectField}
          label="Description"
        >
          {serializable_inventory_item &&
            serializable_inventory_item.sort((a, b) => a.value.localeCompare(b.value)).map((x) => (
              <option key={x.url} value={x.value}>
                {x.value}
              </option>
            ))}
        </Field>
      </ReactBootstrap.Col>
        <ReactBootstrap.Col style={{display:"flex",flexWrap:"wrap"}} xs="12">
            {partNumbers?.length>3 && <ReactBootstrap.Form.Control
        type="text"
        id="search text "
        placeholder="Search Part Numbers"
        onChange={(e) => setPartNumbersSearchText(e.target.value)}
      />}
        {partNumbers &&
            partNumbers.filter(x=>!partNumbersSearchText || x.toLowerCase()?.startsWith(partNumbersSearchText.toLowerCase())).sort(
                (a, b) => a.localeCompare(b)).map((pN, index) => (
            <Field
              name="part_number"
              value={pN}
                     validate={
            partNumbers && partNumbers.length ? [validations.required] : []
          }
              key={index}
              label={<span>{upperCase(pN)} {user && (user.role === 'SuperUser' || user.is_superuser || user.role === 'Privileged') &&<ReactBootstrap.Button style={{float:"right"}} size={'sm'} variant={'danger'}
                     onClick={() => {
                    new rest.SerializableInventoryService().hide_part_number(
                        description,
                        pN).then((res) => {
                            onDescriptionChange()
                           dispatch(showSuccessToast('Success', 'Part Number deleted'))
                    })
                }}
                > {ICONS.DELETE}</ReactBootstrap.Button>} </span>}
              component={renderers.renderRadioFieldWithClickableLabel}
              type="radio"
            />
          ))}
   </ReactBootstrap.Col>

      {/*<ReactBootstrap.Col xs="12">*/}
      {/*  <Field*/}
      {/*    name="part_number"*/}
      {/*    as="select"*/}
      {/*    validate={*/}
      {/*      partNumbers && partNumbers.length ? [validations.required] : []*/}
      {/*    }*/}
      {/*    component={renderers.renderSelectField}*/}
      {/*    label="Part Number"*/}
      {/*  >*/}
      {/*    {partNumbers &&*/}
      {/*      partNumbers.sort((a, b) => a.localeCompare(b)).map((x) => (*/}
      {/*       <span> <option key={x} value={x}>*/}
      {/*            {x}*/}

      {/*        </option> <ReactBootstrap.Button*/}
      {/*                onClick={() => {*/}
      {/*                    new rest.SerializableInventoryService().hide_part_number(x).then((res) => {*/}
      {/*                          onDescriptionChange()*/}
      {/*                        dispatch(showSuccessToast('Success', 'Part Number deleted'))*/}
      {/*                    })*/}
      {/*                }}*/}
      {/*                > x</ReactBootstrap.Button></span>*/}
      {/*      ))}*/}
      {/*  </Field>*/}
      {/*</ReactBootstrap.Col>*/}
      <ReactBootstrap.Col xs="12">
        <Field
          name="quantity"
          label="Quantity"
          validate={[validations.required,validations.minValue(1)]}
          component={renderers.renderField}
          type="text"
        />
      </ReactBootstrap.Col>
      <ReactBootstrap.Col xs="12">
        <Field
          name="amount"
          label="Total Amount"
          validate={[validations.required]}
          component={renderers.renderField}
          type="text"
        />
      </ReactBootstrap.Col>
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
NonSerializedOrderLineForm = reduxForm({
  form: FORM_NAME,
})(NonSerializedOrderLineForm)

const selector = formValueSelector(FORM_NAME)
NonSerializedOrderLineForm = connect((state) => {
     // can select values individually
  const description = selector(state, 'description')
  return {
    description,
  }
})(NonSerializedOrderLineForm)
export const SerializableOrderLineDeleteButton = ({ticket, record, onDelete }) => {
  const dispatch = useDispatch()
  let onReturnConfirm = function () {
    new rest.NonSerializedOrderLineService(record.url)
      .makeDeleteRequest()
      .then((response) => {
          const serializable_order_lines = ticket.serializable_order_lines.map((l) => {
           return l.url === record.url ? response : l
       }
      )
   const t = {...ticket,serializable_order_lines:serializable_order_lines}
      onDelete(t)

        dispatch(
          showSuccessToast('Success', 'Non Serialized Orderline deleted')
        )
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }
  return (
    <>
      <components.Confirm
        onConfirm={onReturnConfirm}
        body="Are you sure you want to return this item?"
        confirmText="Confirm return item"
        confirmBSStyle="danger"
        title="Confirm return item"
      >
        <ReactBootstrap.Button
          disabled={record.is_deleted}
          variant="danger"
          eventKey="1"
        >
          {components.ICONS.DELETE} Delete
        </ReactBootstrap.Button>
      </components.Confirm>
    </>
  )
}

const SerializableOrderLine = ({ticket, serializableOrderLine, onTicketUpdate }) => {
  return (
    <div>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col className="p-0" xs="6">
          <strong>Description:</strong>
          {serializableOrderLine.description}
          <sub>
            <Moment fromNow>{serializableOrderLine.created_at}</Moment>
          </sub>
          <br />
          <strong>Quantity:</strong> {serializableOrderLine.amount}
          <br />
          <strong>Part Number :</strong>
          {serializableOrderLine.part_number}
          <br />
          <strong>Amount : </strong>
          {serializableOrderLine.amount}
        </ReactBootstrap.Col>
        <ReactBootstrap.Col className="text-end p-0" xs="6">
          <SerializableOrderLineDeleteButton
           ticket={ticket}
            onDelete={onTicketUpdate}
            record={serializableOrderLine}
          />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </div>
  )
}

export const TicketNonSerializedOrderLines = ({ ticket, onTicketUpdate }) => {
  const dispatch = useDispatch()
  const createNonSerializedOrderLines = (values) => {
    values.ticket = ticket.url
    new rest.SerializableOrderLineService()
      .makePostRequest(values)
      .then((response) => {
        onTicketUpdate({...ticket,serializable_order_lines:[response,...ticket.serializable_order_lines]})
        dispatch(
          showSuccessToast(
            'Success',
            'Ticket Non SerializedOrderLines created.'
          )
        )
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }
  return (
    <ReactBootstrap.Card className="mt-5">
      <ReactBootstrap.Card.Title className="card-header bg-dark text-white card-header">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs="6">
            Non Serialized Order Lines
          </ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-end" xs="6">
            <Slider
              title={components.ICONS.PLUS}
              header={
                <>
                  <span className="mr-3">{components.ICONS.PLUS}</span>
                  <span>Add Non Serialized Order Lines</span>
                </>
              }
            >
              <NonSerializedOrderLineForm
                ticket={ticket}
                onSubmit={createNonSerializedOrderLines}
              />
            </Slider>
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Title>
      <ReactBootstrap.Card.Body>
        {ticket.serializable_order_lines.length ? (
          <components.ItemList
            itemRenderer={(index, key) => {
              return (
                <ReactBootstrap.Col
                  key={ticket.serializable_order_lines[index].url}
                >
                  <SerializableOrderLine
                    ticket={ticket}
                    onTicketUpdate={onTicketUpdate}
                    serializableOrderLine={
                      ticket.serializable_order_lines[index]
                    }
                  />
                </ReactBootstrap.Col>
              )
            }}
            length={ticket.serializable_order_lines.length}
          />
        ) : (
          <ReactBootstrap.Alert variant={'info'}>
            No previous non serialized order lines found.
          </ReactBootstrap.Alert>
        )}
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
